import { render, staticRenderFns } from "./IconLocation.vue?vue&type=template&id=d2f87e5a&scoped=true&"
import script from "./IconLocation.vue?vue&type=script&lang=js&"
export * from "./IconLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f87e5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2f87e5a')) {
      api.createRecord('d2f87e5a', component.options)
    } else {
      api.reload('d2f87e5a', component.options)
    }
    module.hot.accept("./IconLocation.vue?vue&type=template&id=d2f87e5a&scoped=true&", function () {
      api.rerender('d2f87e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconLocation.vue"
export default component.exports